<script>
import { mapGetters } from 'vuex'
import moment from "moment"

import Translatable from '@src/mixins/translatable.js'

export default {
  mixins: [
    Translatable
  ],
  computed: {
    ...mapGetters('currentNews', [
      'noticeList'
    ]),
    ...mapGetters('attractions', [
      'getAttractionId',
      'getAttraction'
    ]),
    actualNoticeList() {
      return this.noticeList.filter(notice => moment().isBetween(notice.startDate, notice.endDate))
    },
  },
}
</script>

<template>
  <div class="content">
    <template v-for="notice in actualNoticeList">
      <router-link v-if="getAttractionId(notice.attraction)"
        :key="notice._id"
        :to="{
          name: 'attraction',
          params: {
            slug: getAttractionId(notice.attraction).slug,
          },
        }"
        class="card link"
      >
        <div class="title-container">
          <router-link v-if="getAttractionId(notice.attraction)"
            :to="{
              name: 'attraction',
              params: {
                slug: getAttractionId(notice.attraction).slug,
              },
            }"
            class="link"
          >
            <p class="title">{{ getTranslatedContent('title', notice.content) }}</p>
          </router-link>
          <p v-else class="title">{{ getTranslatedContent('title', notice.content) }}</p>
          <!-- <p class="status">{{ 'notice.status' }}</p> -->
          <p class="date">{{ notice.startDate | ddmmYYYY }} - {{ notice.endDate | ddmmYYYY }}</p>
        </div>
        <div class="text-container">
          <p class="text" v-html="getTranslatedContent('text', notice.content)"></p>
        </div>
      </router-link>
      <div v-else
        :key="notice._id"
        class="card not-assigned"
      >
        <div class="title-container">
            <p class="title not-assigned">{{ getTranslatedContent('title', notice.content) }}</p>
          <p class="date">{{ notice.startDate | ddmmYYYY }} - {{ notice.endDate | ddmmYYYY }}</p>
        </div>
        <div class="text-container">
          <p class="text" v-html="getTranslatedContent('text', notice.content)"></p>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.link {
  text-decoration: none;
}

.content {
  display: flex;
  width: 1140px;
  flex-wrap: wrap;
}

.card {
  width: 100%;
  display: flex;
  justify-content: space-between;
  min-height: 90px;
  height: auto;
  border-bottom: 1px solid $dark-gray;
  padding: 33px 0 17px 28px;
  cursor: pointer;

  &.not-assigned {
    cursor: auto;
    user-select: none;
  }
}

.title-container {
  width: 254px;
}

.title {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-style: normal;
  font-size: 18px;
  line-height: 23px;
  color: $black;
  cursor: pointer;

  &:hover {
    color: $gray;
  }

  &.not-assigned {
    cursor: auto;
    user-select: none;

    &:hover {
      color: $black;
    }
  }
}

.status {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-style: normal;
  font-size: 16px;
  line-height: 21px;
  color: $dark-blue;
  margin-top: 3px;
}

.date {
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  color: $gray;
  margin-top: 10px;
}

.text-container {
  width: 779px;

  ::v-deep a {
    color: $gray;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.text {
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  color: $black;
}

@media only screen and (max-width: $screen-width-xs) {
  .content {
    width:  100%;
  }

  .card {
    flex-direction: column;
    padding: 20px 8px 0;
  }

  .title-container, .text-container  {
    width: 100%;
  }

  .text {
    margin: 12px 0 22px;
    // opacity: 0.8;
  }
}
</style>
